import { useEffect, useState } from "react";
import platformAPI from "../../../services/platformApi";
import PlatformPageHeader from "./PlatformPageHeader";
import s from "./platformAdmin.module.css";

const ACTION_LABELS = {
  "platform.clinic_status": "Статус клуба",
  "platform.clinic_billing": "Биллинг клуба",
};

function formatWhen(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("ru-RU", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function metaPreview(meta) {
  if (!meta || typeof meta !== "object") return "—";
  const entries = Object.entries(meta).slice(0, 3);
  if (!entries.length) return "—";
  return entries.map(([k, v]) => `${k}: ${String(v)}`).join(" · ");
}

export default function PlatformAuditLog() {
  const [logs, setLogs] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    platformAPI
      .getAuditLogs()
      .then((r) => setLogs(r.logs || []))
      .catch((e) =>
        setErr(e.response?.data?.error || "Не удалось загрузить журнал"),
      )
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className={s.page}>
      <PlatformPageHeader
        mobileOnlyBack
        backTo="/admin/more"
        backLabel="Ещё"
        title="Журнал"
        lead="Изменения статусов и биллинга клубов."
      />

      {err ? <div className={s.alertError}>{err}</div> : null}
      {loading ? <div className={s.loading}>Загрузка…</div> : null}

      {!loading && logs.length === 0 ? (
        <p className={s.emptyHint}>Записей пока нет.</p>
      ) : null}

      {!loading && logs.length > 0 ? (
        <>
          <div className={s.mobileCardList}>
            {logs.map((row) => (
              <article key={row.id} className={s.mobileDataCard}>
                <div className={s.mobileDataCardTop}>
                  <strong>{ACTION_LABELS[row.action] || row.action}</strong>
                  <span className={s.mobileDataCardTime}>
                    {formatWhen(row.created_at)}
                  </span>
                </div>
                <div className={s.mobileDataCardMeta}>
                  <span>Клуб: {row.entity_id?.slice(0, 8) || "—"}</span>
                </div>
                <p className={s.mobileDataCardHint}>{metaPreview(row.meta)}</p>
              </article>
            ))}
          </div>

          <div className={`${s.tableWrap} ${s.desktopOnlyBlock}`}>
            <table className={s.dataTable}>
              <thead>
                <tr>
                  <th>Когда</th>
                  <th>Действие</th>
                  <th>Клуб</th>
                  <th>Детали</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((row) => (
                  <tr key={row.id}>
                    <td>{formatWhen(row.created_at)}</td>
                    <td>{ACTION_LABELS[row.action] || row.action}</td>
                    <td>{row.entity_id?.slice(0, 8) || "—"}</td>
                    <td>
                      <code className={s.codeInline}>
                        {JSON.stringify(row.meta || {})}
                      </code>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : null}
    </div>
  );
}
